import React from 'react';
import AdminTemplates from '../../components/AdminTemplate/default';

const index = () => {
  return (
    <div className="pt-10 max-w-[1600px] mx-auto">
      <h1 className="text-2xl text-center font-extrabold pb-10">
        Admin Templates
      </h1>
      <AdminTemplates />
    </div>
  );
};

export default index;
